import {blue700, green700, orange700, red700} from "assets/jss/main";

import {LineItemStatus} from "utils/LineItemStatus";

export const STATUS_TABS = [
    {
        status: LineItemStatus.PENDING,
        countKey: 'pending',
        labelId: 'oms.order.list.tab.pending',
        theme: 'yellow',
    },
    {
        status: LineItemStatus.RESERVED,
        countKey: 'reserved',
        labelId: 'oms.order.list.tab.reserved',
        theme: 'purple',
    },
    {
        status: LineItemStatus.TO_SHIP,
        countKey: 'toShip',
        labelId: 'oms.order.list.tab.toShip',
        theme: 'default',
        badgeTextColor: blue700
    },
    {
        status: LineItemStatus.CONFIRMED,
        countKey: 'confirmed',
        labelId: 'oms.order.list.tab.confirmed',
        theme: 'online',
        badgeTextColor: green700
    },
    ...(process.env.REACT_APP_RETURN_ENABLED ? [
        {
            status: 'returning',
            countKey: 'returning',
            labelId: 'oms.order.list.tab.returning',
            theme: 'warning',
            badgeTextColor: orange700
        }
    ] : []),
    {
        status: LineItemStatus.CANCELED,
        countKey: 'canceled',
        labelId: 'oms.order.list.tab.canceled',
        theme: 'error',
        badgeTextColor: red700
    },
];
